import { useRef } from 'react'
import styled from '@emotion/styled'

const VideoView = styled.video`
  position: relative;
  z-index: 1;
  flex: 1;
  object-fit: cover;
  object-position: center;
`

const Video = ({
  src,
  poster,
  preload = 'auto',
  autoplay = true,
  style,
}: {
  src?: string
  poster?: string | null
  preload?: string
  autoplay?: boolean
  style?: React.CSSProperties
}) => {
  const videoRef = useRef(null)
  // const video = videoRef.current
  // const isReady = video ? video.readyState >= video.HAVE_FUTURE_DATA : false

  // useEffect(() => {
  //   if (isReady) {
  //     setLoaded(true)
  //   }
  // }, [isReady])

  return (
    <>
      {/* {!loaded && <BackgroundLoading zIndex={2} />} */}
      <VideoView
        ref={videoRef}
        poster={poster || undefined}
        preload={preload}
        autoPlay={autoplay}
        muted={true}
        loop={true}
        playsInline={true}
        style={style}
      >
        <source src={src} type="video/mp4" />
        <a href={src}>Download the video.</a>
      </VideoView>
    </>
  )
}

export default Video
